import React from 'react';
import { Award } from 'lucide-react';

const MobileSummary = ({ departmentsToUse, getDepartmentProgress }) => {
  return (
    <div className="mt-8 bg-white dark:bg-dark-card rounded-lg shadow-sm border border-gray-100 dark:border-dark-default p-4">
      <h2 className="text-lg font-medium text-gray-800 dark:text-white mb-3 flex items-center">
        <Award size={18} className="mr-2 text-green-600 dark:text-green-400" />
        Department Overview
      </h2>
      <div className="space-y-3">
        {departmentsToUse.map(dept => {
          const deptProgress = getDepartmentProgress(dept.tasks);
          const tasksCompleted = dept.tasks.filter(t => t.status === 'completed').length;
          const tasksInProgress = dept.tasks.filter(t => t.status === 'in-progress').length;
          const tasksNotStarted = dept.tasks.filter(t => t.status === 'not-started').length;
          
          return (
            <div key={dept.name} className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-800 rounded-lg">
              <div className="flex items-center">
                <div className="mr-3 text-green-600 dark:text-green-400">{dept.icon}</div>
                <span className="font-medium text-gray-800 dark:text-white">{dept.name}</span>
              </div>
              <div className="flex items-center">
                <div className="flex items-center mr-3 bg-white dark:bg-gray-700 px-2 py-1 rounded-md border border-gray-100 dark:border-gray-600 text-xs">
                  <span className="text-green-600 dark:text-green-400 font-medium">{tasksCompleted}</span>
                  <span className="mx-1 text-gray-300 dark:text-gray-500">/</span>
                  <span className="text-yellow-500 dark:text-yellow-400">{tasksInProgress}</span>
                  <span className="mx-1 text-gray-300 dark:text-gray-500">/</span>
                  <span className="text-gray-400 dark:text-gray-500">{tasksNotStarted}</span>
                </div>
                <div className="w-16 bg-gray-200 dark:bg-gray-700 rounded-full h-2 overflow-hidden">
                  <div 
                    className="h-2 rounded-full transition-all duration-1000 ease-out"
                    style={{ 
                      width: `${deptProgress}%`,
                      backgroundColor: deptProgress === 100 ? '#43a047' : 
                                    deptProgress > 50 ? '#ff6e40' : '#4caf50'
                    }}
                  ></div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MobileSummary;